<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #FAF5F2;">
      <v-flex>
        <v-layout justify-end v-if="isRead">
          <v-flex class="text-right">
            <v-btn dark color="gray" @click="printPage()">
              <v-icon>print</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout mb-4>
          <v-flex style="font-size: 28px;font-weight: bold;color: #737373">
            <span>แบบฟอร์ม</span>
          </v-flex>
        </v-layout>
        <div id="print" >
          <div class="print-form">
        <v-layout mx-6>
          <v-flex>
            <v-layout style="background-color: #3E7662;">
              <v-flex
                my-4
                ml-8
                style="text-align: left;font-size: 28px;color: white"
              >
                <div style="font-weight: bold">
                  แบบตรวจสอบเอกสารชี้แจงข้อมูลแก่อาสาสมัคร
                </div>
                <div style="font-size: 18px;">
                  Consent Form Elements Checklist
                </div>
              </v-flex>
              <v-flex
                ml-8
                pt-8
                pr-8
                style="text-align: right;font-weight: bold;font-size: 13px;color: white"
              >
                RO 04_1_2563
              </v-flex>
            </v-layout>

            <!-- Start Form -->

            <!-- Card 1 -->
            <v-card class="mb-12">
              <v-layout>
                <v-flex class="text-start ml-8 mt-3">
                  <span style="color: #CC3D45"
                    >(สำหรับโครงการที่มีเอกสารชี้แจงข้อมูลเท่านั้น)</span
                  >
                </v-flex>
              </v-layout>

              <v-layout pa-12 class="justify-center">
                <v-flex xs10>
                  <!-- row 1 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center font-weight-bold">
                      รหัสโครงร่างการวิจัย
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        readonly
                        :model="form.researchCode"
                        hide-detail
                        @update-data="updateData('researchCode', $event)"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <!-- row 2 -->
                  <v-layout mb-8>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center font-weight-bold">
                      ชื่อผู้วิจัยหลัก
                    </v-flex>
                    <v-flex xs4 class="text-start">
                      <TextfieldForm
                        readonly
                        :model="form.firstName"
                        hide-detail
                        @update-data="updateData('firstName', $event)"
                      />
                    </v-flex>
                    <v-flex mx-4 xs1 class="d-flex justify-end align-center font-weight-bold">
                      นามสกุล
                    </v-flex>
                    <v-flex>
                      <TextfieldForm
                        readonly
                        :model="form.lastName"
                        hide-detail
                        @update-data="updateData('lastName', $event)"
                      />
                    </v-flex>
                  </v-layout>
                  <!-- row 3 -->
                  <v-layout>
                    <v-flex mr-4 xs2 class="d-flex justify-end align-center font-weight-bold">
                      ชื่อโครงการวิจัย
                    </v-flex>
                    <v-flex>
                      <TextareaForm
                        readonly
                        :model="form.researchName"
                        hide-detail
                        @update-data="updateData('researchName', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 2 -->
            <v-card class="mb-12">
              <!-- Table -->
              <v-layout class="table-ro4-1">
                <v-flex class="table-style-ro04-1">
                  <table class="table-fill-ro04-1">
                    <!-- thead -->
                    <thead>
                      <tr style="border-top:5px solid #544A44;">
                        <th width="60%" class="text-center">
                          การมีผลประโยชน์ทับซ้อน
                        </th>
                        <th width="5%" class="text-center">มี</th>
                        <th width="5%" class="text-center">ไม่มี</th>
                        <th width="30%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- row 1 -->
                      <tr class="row2" style="border-top: none">
                        <td class="text-left pl-12">
                          <span>ผู้วิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox1.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'hasResearcher')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox1.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'hasResearcher')"
                          ></v-checkbox>
                        </td>
                        <td class="text-center">
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.adviceResearcher)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.adviceResearcher"
                            @update-data="updateData('adviceResearcher', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- row 2 -->
                      <tr class="row2">
                        <td class="text-left pl-12">
                          <span>ผู้วิจัยร่วม</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox2.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'hasCoResearcher')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox2.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'hasCoResearcher')"
                          ></v-checkbox>
                        </td>
                        <td class="text-center">
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.adviceCoResearcher)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.adviceCoResearcher"
                            @update-data="updateData('adviceCoResearcher', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 3 -->
            <v-card class="mb-12">
              <!-- Table -->
              <v-layout class="table-ro4-1">
                <v-flex class="table-style-ro04-1">
                  <table class="table-fill-ro04-1">
                    <!-- thead -->
                    <thead>
                      <tr style="border-top:5px solid #544A44;">
                        <th width="60%" class="text-center">
                          กระบวนการขอความยินยอม
                        </th>
                        <th width="5%" class="text-center">เหมาะสม</th>
                        <th width="5%" class="text-center">ไม่เหมาะสม</th>
                        <th width="5%" class="text-center">ไม่ เกี่ยวข้อง</th>
                        <th width="30%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- row 1 -->
                      <tr class="row2" style="border-top: none">
                        <td class="text-left pl-12">
                          <span>กระบวนการขอความยินยอม</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox3.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'consentRequest')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox3.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'consentRequest')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox3.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'consentRequest')"
                          ></v-checkbox>
                        </td>
                        <td class="text-center">
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.consentRequestAdvice)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.consentRequestAdvice"
                            @update-data="updateData('consentRequestAdvice', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- row 2 -->
                      <tr class="row2">
                        <td class="text-left px-12" colspan="5">
                          <div
                            class="px-4 row d-flex justify-space-between justify-center align-center"
                          >
                            <div class="my-4">ข้อคิดเห็นและคำแนะนำ</div>
                            <div class="d-flex justify-end"></div>
                            <v-btn
                              color="#3e7662"
                              dark
                              @click="onClickGenerate('adviceTextBox')"
                            >
                              Generate
                            </v-btn>
                          </div>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.adviceTextBox)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :model="form.adviceTextBox"
                            :readonly="isRead"
                            @update-data="updateData('adviceTextBox', $event)"
                              @focus-out="autoSave()"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Card 4 -->
            <v-card class="mb-12">
              <!-- Table -->
              <v-layout class="table-ro4-1">
                <v-flex class="table-style-ro04-1">
                  <table class="table-fill-ro04-1">
                    <!-- thead 1 -->
                    <thead>
                      <tr style="border-top:5px solid #544A44;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">มี</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="10%" class="text-center">ไม่เกี่ยวข้อง</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate1 -->
                      <tr style="border-top: none">
                        <td>
                          <span>1.</span>
                        </td>
                        <td>
                          <span>ชื่อเรื่อง ตรงกับ ชื่อเรื่องของโครงการวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox4.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox4.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox4.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate1')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate1)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate1"
                            @update-data="updateData('boxAppropriate1', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate2 -->
                      <tr style="border-top: none">
                        <td>
                          <span>2.</span>
                        </td>
                        <td>
                          <span>ชื่อผู้ให้ทุนวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox5.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox5.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox5.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate2')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate2)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate2"
                            @update-data="updateData('boxAppropriate2', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate3 -->
                      <tr style="border-top: none">
                        <td>
                          <span>3.</span>
                        </td>
                        <td>
                          <span>วันที่สำหรับลงนาม ยินยอมร่วมโครงการวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox6.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox6.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox6.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate3')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate3)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate3"
                            @update-data="updateData('boxAppropriate3', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate4 -->
                      <tr style="border-top: none">
                        <td>
                          <span>4.</span>
                        </td>
                        <td>
                          <span
                            >ชื่อของผู้วิจัย ที่อยู่
                            และเบอร์โทรศัพท์ที่ติดต่อได้
                            ในและนอกเวลาราชการ</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox7.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox7.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox7.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate4')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate4)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate4"
                            @update-data="updateData('boxAppropriate4', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 2 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate5 -->
                      <tr style="border-top: none">
                        <td>
                          <span>5.</span>
                        </td>
                        <td>
                          <span>ที่มาและวัตถุประสงค์ของการทำวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox8.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox8.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox8.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate5')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate5)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate5"
                            @update-data="updateData('boxAppropriate5', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate6 -->
                      <tr style="border-top: none">
                        <td>
                          <span>6.</span>
                        </td>
                        <td>
                          <span
                            >เหตุผลที่บุคคลนั้นได้รับการเชิญชวนให้เข้าร่วมโครงการวิจัยเพราะมีคุณสมบัติที่เหมาะสมอย่างไร
                            (เกณฑ์การคัดเข้า/คัดออก)</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox9.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox9.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox9.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate6')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate6)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate6"
                            @update-data="updateData('boxAppropriate6', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate7 -->
                      <tr style="border-top: none">
                        <td>
                          <span>7.</span>
                        </td>
                        <td>
                          <span>ระยะเวลาที่จะต้องร่วมในโครงการวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox10.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox10.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox10.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate7')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate7)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate7"
                            @update-data="updateData('boxAppropriate7', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate8 -->
                      <tr style="border-top: none">
                        <td>
                          <span>8.</span>
                        </td>
                        <td>
                          <span>ต้องเดินทางไปพบผู้วิจัยตามนัดกี่ครั้ง</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox11.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox11.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox11.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate8')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate8)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate8"
                            @update-data="updateData('boxAppropriate8', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 3 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate9 -->
                      <tr style="border-top: none">
                        <td>
                          <span>9.</span>
                        </td>
                        <td>
                          <span
                            >มีผู้เข้าร่วมโครงการวิจัยนี้รวมทั้งสิ้นกี่คน</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox12.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox12.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox12.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate9')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate9)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate9"
                            @update-data="updateData('boxAppropriate9', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate10 -->
                      <tr style="border-top: none">
                        <td>
                          <span>10.</span>
                        </td>
                        <td>
                          <span
                            >ผู้เข้าร่วมโครงการวิจัยจะต้องปฏิบัติตามขั้นตอนการวิจัยอย่างไร</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox13.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox13.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox13.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate10')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate10)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate10"
                            @update-data="updateData('boxAppropriate10', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate11 -->
                      <tr style="border-top: none">
                        <td>
                          <span>11.</span>
                        </td>
                        <td>
                          <span
                            >ความเสี่ยง ความไม่สบายกายและจิตใจ
                            ที่จะได้รับในการเข้าร่วมโครงการวิจัย
                            รวมถึงต้องแจ้งว่าอาจจะมี
                            เหตุการณ์ที่ยังคาดไม่ถึงเกิดขึ้นได้เช่นการแพ้ยา
                            แม้ว่าจะไม่เคยมีรายงานมาก่อนเป็นต้น</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox14.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox14.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox14.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate11')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate11)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate11"
                            @update-data="updateData('boxAppropriate11', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate12 -->
                      <tr style="border-top: none">
                        <td>
                          <span>12.</span>
                        </td>
                        <td>
                          <span
                            >ประโยชน์ที่คาดว่าจะได้รับจากโครงการวิจัย
                            ทั้งโดยตรงต่อผู้เข้าร่วมโครงการวิจัยเอง หรือ
                            อาจไม่ได้รับประโยชน์โดยตรงแต่ผลการวิจัยที่ได้จะเป็นประโยชน์ต่อส่วนรวมในอนาคต</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox15.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox15.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox15.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate12')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate12)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate12"
                            @update-data="updateData('boxAppropriate12', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate13 -->
                      <tr style="border-top: none">
                        <td>
                          <span>13.</span>
                        </td>
                        <td>
                          <span
                            >ค่าตอบแทนที่จะได้รับจากการเข้าร่วมโครงการวิจัย เช่น
                            เป็นค่าเดินทางค่าชดเชยที่ต้องสูญเสียรายได้
                            แต่ต้องไม่มากจนเป็นเหตุจูงใจให้เข้าร่วมโครงการวิจัยโดยไม่เหมาะสม</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox16.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox16.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox16.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate13')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate13)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate13"
                            @update-data="updateData('boxAppropriate13', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate14 -->
                      <tr style="border-top: none">
                        <td>
                          <span>14.</span>
                        </td>
                        <td>
                          <span
                            >ค่าใช้จ่ายที่จะต้องเสียในการเข้าร่วมโครงการวิจัย
                            เช่น ค่าใช้จ่ายในการตรวจที่ต้องรับผิดชอบเอง</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox17.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox17.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox17.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate14')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate14)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate14"
                            @update-data="updateData('boxAppropriate14', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate15 -->
                      <tr style="border-top: none">
                        <td>
                          <span>15.</span>
                        </td>
                        <td>
                          <span
                            >ทางเลือกอื่นหากไม่ได้เข้าร่วมโครงการวิจัย
                            เช่นหากไม่ได้เข้าร่วมโครงการวิจัยนี้
                            จะได้รับการรักษา พยาบาลอย่างไร</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox18.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate15')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox18.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate15')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox18.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate15')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate15)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate15"
                            @update-data="updateData('boxAppropriate15', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate16 -->
                      <tr style="border-top: none">
                        <td>
                          <span>16.</span>
                        </td>
                        <td>
                          <span
                            >การรักษาความลับของข้อมูลที่เป็นส่วนตัวของผู้เข้าร่วมโครงการวิจัย
                            นอกจากนักวิจัยแล้ว มีผู้ใดหรือ
                            คณะบุคคลใดที่จะมาตรวจสอบข้อมูลของผู้เข้าร่วมโครงการวิจัยได้บ้าง
                            เช่นข้อมูลจะต้องถูกส่งไปยัง บริษัทยาที่เป็นผู้ให้ทุน
                            คณะกรรมการจริยธรรมสามารถตรวจสอบข้อมูลของการวิจัยได้เช่นเดียวกัน</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox19.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate16')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox19.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate16')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox19.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate16')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate16)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate16"
                            @update-data="updateData('boxAppropriate16', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate17 -->
                      <tr style="border-top: none">
                        <td>
                          <span>17.</span>
                        </td>
                        <td>
                          <span
                            >หากเกิดการบาดเจ็บหรือเจ็บป่วยหรือเกิดผลข้างเคียงอันไม่พึงประสงค์ที่เป็นผลมาจากการวิจัยโดยตรงอาสาสมัครจะได้รับการปฏิบัติอย่างไรบ้าง
                            และใครจะเป็นผู้รับผิดชอบในการรักษาพยาบาลรวมถึง
                            ค่าใช้จ่ายในการรักษาตัวแบบผู้ป่วยในโรงพยาบาล เป็นต้น
                            ควรระบุให้ชัดเจน</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox20.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate17')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox20.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate17')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox20.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate17')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate17)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate17"
                            @update-data="updateData('boxAppropriate17', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate18 -->
                      <tr style="border-top: none">
                        <td>
                          <span>18.</span>
                        </td>
                        <td>
                          <span
                            >เมื่อเกิดเหตุการณ์อันไม่พึงประสงค์ผู้เข้าร่วมโครงการวิจัยจะติดต่อกับผู้วิจัยหลักได้อย่างไร
                            ควรมี ชื่อ ที่อยู่ เบอร์โทรศัพท์ ที่จะติดต่อได้ 24
                            ชั่วโมง
                            และเมื่อผู้เข้าร่วมโครงการรู้สึกว่าได้รับการปฏิบัติอย่างไม่เป็นธรรม
                            สามารถ
                            ติดต่อร้องทุกข์ต่อคณะกรรมการได้ด้วยวิธีใด</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox21.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate18')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox21.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate18')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox21.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate18')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate18)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate18"
                            @update-data="updateData('boxAppropriate18', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate19 -->
                      <tr style="border-top: none">
                        <td>
                          <span>19.</span>
                        </td>
                        <td>
                          <span>
                            ผู้เข้าร่วมโครงการวิจัย
                            สามารถถอนตัวจากโครงการวิจัยได้ตลอดเวลา
                            และไม่จำเป็นต้องชี้แจง เหตุผลในการถอนตัว
                            ในขณะเดียวกันผู้วิจัย หรือผู้ให้ทุนการวิจัย
                            อาจขอให้ผู้เข้าร่วม
                            โครงการวิจัยออกจากโครงการวิจัยได้เช่นกัน
                            เมื่อมีเหตุผล เช่นอาจเป็นอันตรายต่อผู้เข้าร่วม
                            โครงการวิจัยเอง
                            หรือผู้เข้าร่วมโครงการวิจัยมิได้ปฏิบัติตัวตามขั้นตอนที่ได้ตกลงไว้ในการดำเนินการวิจัย
                            เป็นต้น
                          </span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox22.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate19')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox22.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate19')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox22.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate19')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate19)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate19"
                            @update-data="updateData('boxAppropriate19', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 4 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate20 -->
                      <tr style="border-top: none">
                        <td>
                          <span>20.</span>
                        </td>
                        <td>
                          <span
                            >หากมีข้อมูลใหม่ ที่เกี่ยวข้องกับโครงการวิจัย
                            ผู้วิจัยจะต้องแจ้งให้ผู้เข้าร่วมโครงการวิจัยทราบด้วย
                            (เฉพาะการวิจัยเกี่ยวกับยา)</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox23.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate20')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox23.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate20')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox23.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate20')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate20)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate20"
                            @update-data="updateData('boxAppropriate20', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 5 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">มี</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="10%" class="text-center">ไม่เกี่ยวข้อง</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate21 -->
                      <tr style="border-top: none">
                        <td>
                          <span>21.</span>
                        </td>
                        <td>
                          <span
                            >ผู้เข้าร่วมโครงการวิจัยจะได้รับเอกสารชี้แจงที่มีข้อความเดียวกันกับที่ผู้วิจัยเก็บไว้
                            1 ชุด</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox24.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate21')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox24.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate21')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox24.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate21')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate21)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate21"
                            @update-data="updateData('boxAppropriate21', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 6 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate22 -->
                      <tr style="border-top: none">
                        <td>
                          <span>22.</span>
                        </td>
                        <td>
                          <span
                            >ภาษาที่ใช้จะต้องสละสลวย เข้าใจง่าย
                            ไม่ใช้ศัพท์ทางวิทยาศาสตร์ หรือทางการแพทย์
                            แต่จะต้องเป็น ภาษาที่คนทั่วไปสามารถเข้าใจได้</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox25.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate22')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox25.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate22')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox25.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate22')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate22)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate22"
                            @update-data="updateData('boxAppropriate22', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate23 -->
                      <tr style="border-top: none">
                        <td>
                          <span>23.</span>
                        </td>
                        <td>
                          <span
                            >ผู้เข้าร่วมโครงการวิจัยเข้าร่วมโครงการวิจัยนี้โดยความสมัครใจ
                            ไม่มีการบังคับ</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox26.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate23')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox26.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate23')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox26.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate23')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate23)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate23"
                            @update-data="updateData('boxAppropriate23', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 7 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">มี</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="10%" class="text-center">ไม่เกี่ยวข้อง</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate24 -->
                      <tr style="border-top: none">
                        <td>
                          <span>24.</span>
                        </td>
                        <td>
                          <span>ที่ลงนาม ผู้เข้าร่วมโครงการวิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox27.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate24')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox27.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate24')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox27.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate24')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate24)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate24"
                            @update-data="updateData('boxAppropriate24', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate25 -->
                      <tr style="border-top: none">
                        <td>
                          <span>25.</span>
                        </td>
                        <td>
                          <span>ที่ลงนาม ผู้ขอคำยินยอมหรือผู้วิจัย</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox28.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate25')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox28.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate25')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox28.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate25')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate25)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate25"
                            @update-data="updateData('boxAppropriate25', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate26 -->
                      <tr style="border-top: none">
                        <td>
                          <span>26.</span>
                        </td>
                        <td>
                          <span>ที่ลงนามพยาน (2 คน)</span>
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox29.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate26')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox29.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate26')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox29.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate26')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate26)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate26"
                            @update-data="updateData('boxAppropriate26', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                      <!-- isAppropriate27 -->
                      <tr style="border-top: none">
                        <td>
                          <span>27.</span>
                        </td>
                        <td>
                          <span
                            >กรณีผู้เข้าร่วมโครงการวิจัยเป็นเด็ก (อายุน้อยกว่า18
                            ปี) มีที่ลงนามผู้ปกครองหรือผู้แทนโดยชอบธรรม</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox30.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate27')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox30.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate27')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox30.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate27')"
                          ></v-checkbox>
                        </td>
                        <td>
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate27)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate27"
                            @update-data="updateData('boxAppropriate27', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>

                    <!-- thead 8 -->
                    <thead>
                      <tr style="border-top: none;">
                        <th width="5%" class="text-center">ข้อ</th>
                        <th class="text-left pl-12">
                          ข้อความหนังสือเอกสารชี้แจงข้อมูล/หนังสือแสดงเจตนายินยอม
                        </th>
                        <th width="10%" class="text-center">เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่เหมาะสม</th>
                        <th width="10%" class="text-center">ไม่มี</th>
                        <th width="15%" class="text-center">
                          ข้อคิดเห็นและเสนอแนะ
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <!-- isAppropriate28 -->
                      <tr
                        style="border-top: none;border-bottom: 1px solid rgba(0,0,0,0.5)"
                      >
                        <td>
                          <span>28.</span>
                        </td>
                        <td>
                          <span
                            >กรณีผู้เข้าร่วมโครงการเป็นเด็กอายุตั้งแต่ 7 ขวบ ถึง
                            12 ปี มีหนังสือแสดงความยินยอม (Assent form)
                            ให้เด็กสามารถอ่านทำความเข้าใจได้และมีที่ลงนามของเด็ก</span
                          >
                        </td>
                        <td class="text-xs-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox31.checkbox1"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(1, 'isAppropriate28')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox31.checkbox2"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(2, 'isAppropriate28')"
                          ></v-checkbox>
                        </td>
                        <td class="text-left text-field-center">
                          <v-checkbox
                            :readonly="isRead"
                              v-model="isCheckbox31.checkbox3"
                            color="#3E7662"
                            hide-details
                            @change="checkbox(3, 'isAppropriate28')"
                          ></v-checkbox>
                        </td>
                        <td style="border-bottom: 1px solid rgba(0,0,0,0.5)">
                          <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.boxAppropriate28)"></div>
                          <TextareaForm
                              v-if="!printMode"
                            :readonly="isRead"
                              :model="form.boxAppropriate28"
                            @update-data="updateData('boxAppropriate28', $event)"
                              @focus-out="autoSave()"
                            hide-detail
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-flex>
              </v-layout>

              <v-layout px-12 pt-12>
                <v-flex>
                  <!-- ข้อคิดเห็นและเสนอแนะเพิ่มเติม -->
                  <v-layout mb-4 justify-space-between>
                    <v-flex class="text-start font-weight-bold">
                      <span>ข้อคิดเห็นและเสนอแนะเพิ่มเติม</span>
                    </v-flex>
                    <v-flex class="text-end">
                      <v-btn
                        color="#3e7662"
                        dark
                        @click="onClickGenerate('adviceTextBox2')"
                      >
                        Generate
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout mb-12>
                    <v-flex>
                      <div v-if="printMode" class="text-left" v-html="replaceWithBr(form.adviceTextBox2)"></div>
                      <TextareaForm
                          v-if="!printMode"
                        :readonly="isRead"
                          :model="form.adviceTextBox2"
                        @update-data="updateData('adviceTextBox2', $event)"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- แนะนำให้พบ -->
                  <v-layout>
                    <v-flex class="text-start font-weight-bold mb-2">
                      <span>แนะนำให้พบ</span>
                    </v-flex>
                  </v-layout>
                  <v-layout mt-2 ml-6 style="margin-bottom: 150px">
                    <v-flex class="text-start">
                      <v-radio-group
                          v-model="form.recommendToMeet"
                          @change="updateData('recommendToMeet',$event)"
                          :readonly="isRead"
                      >
                        <v-radio
                            @click="form.expertConsultant = ''"
                          color="#3E7662"
                          style="padding-right: 40px;margin-bottom: 10px"
                          label="ผู้ทบทวน (Reviewer)"
                          value="1"
                        ></v-radio>
                        <v-row>
                          <v-col cols="auto">
                            <v-radio
                              color="#3E7662"
                              @click="form.expertConsultant = ''"
                              label="ผู้เชี่ยวชาญ (Expert consultant) ระบุ"
                              value="2"
                            ></v-radio>
                          </v-col>
                          <v-col style="flex: 1;padding-left: 0">
                            <v-text-field
                              :disabled="form.recommendToMeet !== '2'"
                              color="#3E7662"
                              class="mt-n4"
                              :readonly="isRead"
                              v-model="form.expertConsultant"
                              @change="updateData('expertConsultant',$event)"
                              hide-details
                            />
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>

                  <!-- ผู้ประเมิน -->
                  <v-layout mt-6>
                    <v-flex
                        xs1
                      mt-4
                      mr-2
                        class="font-weight-bold d-flex justify-end align-center"
                    >
                      ผู้ประเมิน
                    </v-flex>
                    <v-flex xs4 class="text-start text-field-center">
                      <v-text-field
                        hide-details
                        :readonly="isRead"
                        v-model="form.signature"
                        color="#3E7662"
                        append-icon="edit"
                      />
                    </v-flex>
                    <v-flex
                        xs1
                      ml-12
                      mt-4
                      mr-2
                        class="font-weight-bold d-flex justify-end align-center"
                    >
                      <span>คนที่</span>
                    </v-flex>
                    <v-flex xs1 class="text-start text-field-center">
                      <v-text-field
                        hide-details
                        :readonly="isRead"
                        v-model="form.order"
                        color="#3E7662"
                      />
                    </v-flex>
                  </v-layout>

                  <!-- Date -->
                  <v-layout mt-8 style="margin-bottom: 100px;">
                    <v-flex xs3>
                      <DateInputForm
                        :readonly="isRead"
                          :model="dateChange"
                        @update-data="updateDate('estimateDate', $event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>

              <v-layout class="pl-12 pb-12">
                <v-flex class="text-start font-weight-bold">
                  <span>สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย พบ.</span>
                </v-flex>
              </v-layout>
            </v-card>

            <!-- Button Save -->
            <v-layout mt-8>
              <v-flex mb-12 style="text-align: right;">
                <v-layout>
                  <v-flex>
                    <v-btn
                      style="color: #3E7662"
                      depressed
                      color="#ffffff"
                      @click="$router.go(-1)"
                      >ย้อนกลับ</v-btn
                    >
                    <v-btn depressed
                           dark
                           class="ml-4"
                           color="#3E7662"
                           @click="save(0)"
                           v-if="(!isRead && !isSubmit) || isStaff">
                      <span>บันทึกข้อมูล</span>
                    </v-btn>
                    <v-btn depressed
                           dark
                           class="ml-4"
                           color="#3E7662"
                           @click="save(1)"
                           v-if="(!isRead && !isSubmit) || isStaff">
                      <span>บันทึกข้อมูลและส่งการประเมิน</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
          </div>
        </div>
        <loading
          color="#527281"
          :active.sync="isLoading"
          :can-cancel="false"
          :is-full-pageAndLine="fullpageAndLine"
        ></loading>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../components/input/TextfieldForm";
import DateInputForm from "../../components/input/DateInputForm";
import TextareaForm from "../../components/input/TextareaForm";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";

export default {
  name: "FormRO02",
  components: {
    TextfieldForm,
    DateInputForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    printMode: false,
    form: {
      researchID: "",
      researchName: "",
      firstName: "",
      lastName: "",
      researchCode: "",
      hasResearcher: "",
      adviceResearcher: "",
      hasCoResearcher: "",
      adviceCoResearcher: "",
      consentRequest: "",
      consentRequestAdvice: "",
      adviceTextBox: "",

      isAppropriate1: "",
      isAppropriate2: "",
      isAppropriate3: "",
      isAppropriate4: "",
      isAppropriate5: "",
      isAppropriate6: "",
      isAppropriate7: "",
      isAppropriate8: "",
      isAppropriate9: "",
      isAppropriate10: "",
      isAppropriate11: "",
      isAppropriate12: "",
      isAppropriate13: "",
      isAppropriate14: "",
      isAppropriate15: "",
      isAppropriate16: "",
      isAppropriate17: "",
      isAppropriate18: "",
      isAppropriate19: "",
      isAppropriate20: "",
      isAppropriate21: "",
      isAppropriate22: "",
      isAppropriate23: "",
      isAppropriate24: "",
      isAppropriate25: "",
      isAppropriate26: "",
      isAppropriate27: "",
      isAppropriate28: "",

      boxAppropriate1: "",
      boxAppropriate2: "",
      boxAppropriate3: "",
      boxAppropriate4: "",
      boxAppropriate5: "",
      boxAppropriate6: "",
      boxAppropriate7: "",
      boxAppropriate8: "",
      boxAppropriate9: "",
      boxAppropriate10: "",
      boxAppropriate11: "",
      boxAppropriate12: "",
      boxAppropriate13: "",
      boxAppropriate14: "",
      boxAppropriate15: "",
      boxAppropriate16: "",
      boxAppropriate17: "",
      boxAppropriate18: "",
      boxAppropriate19: "",
      boxAppropriate20: "",
      boxAppropriate21: "",
      boxAppropriate22: "",
      boxAppropriate23: "",
      boxAppropriate24: "",
      boxAppropriate25: "",
      boxAppropriate26: "",
      boxAppropriate27: "",
      boxAppropriate28: "",

      adviceTextBox2: "",
      recommendToMeet: "",
      expertConsultant: "",
      signature: "",
      order: "",
      date: "",
    },
      recommendToMeet2:"",
    isCheckbox1: { checkbox1: false, checkbox2: false },
    isCheckbox2: { checkbox1: false, checkbox2: false },
    isCheckbox3: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox4: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox5: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox6: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox7: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox8: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox9: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox10: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox11: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox12: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox13: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox14: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox15: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox16: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox17: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox18: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox19: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox20: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox21: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox22: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox23: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox24: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox25: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox26: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox27: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox28: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox29: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox30: { checkbox1: false, checkbox2: false, checkbox3: false },
    isCheckbox31: { checkbox1: false, checkbox2: false, checkbox3: false },
    dateChange: "",
    isRead: false,
    lastKey: "",
    lastValue: "",
    isStaff: false,
    isSubmit: false
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    if (this.user.currentRole === 1) {
      this.isStaff = true
    }
    this.updateDate("estimateDateGet", new Date().toISOString().substr(0, 10));
    this.form.order = this.$route.query.order;
    this.form.signature = this.$route.query.reviewerName;
    this.form.researchName = this.$route.query.nameResearch;
    this.form.firstName = this.$route.query.mainResearcherFirstName;
    this.form.lastName = this.$route.query.mainResearcherLastName;
    this.form.researchCode = this.$route.query.researchCode;
    this.isRead = this.$route.query.isRead === 'true';
    this.updateDate("estimateDate", {
      date: new Date().toISOString().substr(0, 10),
    });

    this.getRO04_1();
  },
  methods: {
    async printPage() {
      this.printMode = true
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
          "#fff";
      await document.querySelectorAll("button").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.querySelectorAll(".v-icon").forEach(function (element) {
        element.style.display = 'none'
      });
      await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
        element.innerHTML = '✓' + element.innerHTML
      })
      await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
        element.innerHTML = '✓ ' + element.innerHTML
      })
      var node = document.getElementById("print");
      var self = this;
      domtoimage
          .toPng(node)
          .then( async function (dataUrl) {
            var img = new Image();
            img.src = dataUrl;
            var page = self.imageToPrint(img);

            var pageLink = "about:blank";
            var pwa = window.open('', "_new");
            pwa.document.open();
            pwa.document.write(page);
            pwa.document.close();
            self.printMode = false
            await document.querySelectorAll("button").forEach(function (element) {
              element.style.display = 'unset'
            });
            await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓', '')
            })
            await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
              element.innerHTML = element.innerHTML.replace('✓ ', '')
            })
            await document.querySelectorAll(".v-icon").forEach(function (element) {
              element.style.display = 'unset'
            });
            document
                .getElementsByClassName("print-form")[0]
                .removeAttribute("style");
          })
          .catch(function (error) {
            Swal.fire({
              title: "กรุณาเปิดการอนุญาต Pop Up!",
              description: "",
              icon: "error",
              confirmButtonColor: "#3E7662",
              cancelButtonColor: "rgb(189, 189, 189)",
              confirmButtonText: "ตกลง",
            }).then(async function() {

              await document.querySelectorAll("button").forEach(function (element) {
                element.style.display = 'unset'
              });
              await document.getElementsByClassName("v-input--checkbox v-input--is-label-active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓', '')
              })
              await document.getElementsByClassName("v-radio v-item--active").forEach(function (element){
                element.innerHTML = element.innerHTML.replace('✓ ', '')
              })
              await document.querySelectorAll(".v-icon").forEach(function (element) {
                element.style.display = 'unset'
              });
              document
                  .getElementsByClassName("print-form")[0]
                  .removeAttribute("style");
            })
          });
    },
    imageToPrint(source) {
      return (
          "<html><body onload='window.print()'><style>@media print {\n" +
          "  @page { margin: 0; }\n" +
          "  html, body {\n" +
          "    margin: 0;\n" +
          "    width: 210mm;\n" +
          "    height: 297mm;\n" +
          "  }\n" +
          "  img {\n" +
          "    margin-top: 10mm;\n" +
          "    margin-left: 20mm;\n" +
          "    width: 170mm;\n" +
          // "    height: 297mm;\n" +
          "  }\n" +
          "}</style>" +
          source.outerHTML +
          "</body></html>"
      );
    },
    replaceWithBr(text){
      if(text)
        return text.replace(/\n/g, '<br/>');
      return ''
    },
    onClickGenerate(text) {
      switch (text) {
        case "adviceTextBox":
          this.form.adviceTextBox =
            this.checkNull("ผู้วิจัย", this.form.adviceResearcher) +
            "\n" +
            this.checkNull("ผู้วิจัยร่วม", this.form.adviceCoResearcher) +
            "\n" +
            this.checkNull(
              "กระบวนการขอความยินยอม",
              this.form.consentRequestAdvice
            ) +
            "\n";
          break;

        case "adviceTextBox2":
          this.form.adviceTextBox2 =
            this.checkNull(
              "ชื่อเรื่อง ตรงกับ ชื่อเรื่องของโครงการวิจัย",
              this.form.boxAppropriate1
            ) +
            "\n" +
            this.checkNull("ชื่อผู้ให้ทุนวิจัย", this.form.boxAppropriate2) +
            "\n" +
            this.checkNull(
              "วันที่สำหรับลงนาม ยินยอมร่วมโครงการวิจัย",
              this.form.boxAppropriate3
            ) +
            "\n" +
            this.checkNull(
              "ชื่อของผู้วิจัย ที่อยู่ และเบอร์โทรศัพท์ที่ติดต่อได้ ในและนอกเวลาราชการ",
              this.form.boxAppropriate4
            ) +
            "\n" +
            this.checkNull(
              "ที่มาและวัตถุประสงค์ของการทำวิจัย",
              this.form.boxAppropriate5
            ) +
            "\n" +
            this.checkNull(
              "เหตุผลที่บุคคลนั้นได้รับการเชิญชวนให้เข้าร่วมโครงการวิจัยเพราะมีคุณสมบัติที่เหมาะสมอย่างไร (เกณฑ์การคัดเข้า/คัดออก)",
              this.form.boxAppropriate6
            ) +
            "\n" +
            this.checkNull(
              "ระยะเวลาที่จะต้องร่วมในโครงการวิจัย",
              this.form.boxAppropriate7
            ) +
            "\n" +
            this.checkNull(
              "ต้องเดินทางไปพบผู้วิจัยตามนัดกี่ครั้ง",
              this.form.boxAppropriate8
            ) +
            "\n" +
            this.checkNull(
              "มีผู้เข้าร่วมโครงการวิจัยนี้รวมทั้งสิ้นกี่คน",
              this.form.boxAppropriate9
            ) +
            "\n" +
            this.checkNull(
              "ผู้เข้าร่วมโครงการวิจัยจะต้องปฏิบัติตามขั้นตอนการวิจัยอย่างไร",
              this.form.boxAppropriate10
            ) +
            "\n" +
            this.checkNull(
              "ความเสี่ยง ความไม่สบายกายและจิตใจ ที่จะได้รับในการเข้าร่วมโครงการวิจัย รวมถึงต้องแจ้งว่าอาจจะมี เหตุการณ์ที่ยังคาดไม่ถึงเกิดขึ้นได้เช่นการแพ้ยา แม้ว่าจะไม่เคยมีรายงานมาก่อนเป็นต้น",
              this.form.boxAppropriate11
            ) +
            "\n" +
            this.checkNull(
              "ประโยชน์ที่คาดว่าจะได้รับจากโครงการวิจัย ทั้งโดยตรงต่อผู้เข้าร่วมโครงการวิจัยเอง หรือ อาจไม่ได้รับประโยชน์โดยตรงแต่ผลการวิจัยที่ได้จะเป็นประโยชน์ต่อส่วนรวมในอนาคต",
              this.form.boxAppropriate12
            ) +
            "\n" +
            this.checkNull(
              "ค่าตอบแทนที่จะได้รับจากการเข้าร่วมโครงการวิจัย เช่น เป็นค่าเดินทางค่าชดเชยที่ต้องสูญเสียรายได้ แต่ต้องไม่มากจนเป็นเหตุจูงใจให้เข้าร่วมโครงการวิจัยโดยไม่เหมาะสม",
              this.form.boxAppropriate13
            ) +
            "\n" +
            this.checkNull(
              "ค่าใช้จ่ายที่จะต้องเสียในการเข้าร่วมโครงการวิจัย เช่น ค่าใช้จ่ายในการตรวจที่ต้องรับผิดชอบเอง",
              this.form.boxAppropriate14
            ) +
            "\n" +
            this.checkNull(
              "ทางเลือกอื่นหากไม่ได้เข้าร่วมโครงการวิจัย เช่นหากไม่ได้เข้าร่วมโครงการวิจัยนี้ จะได้รับการรักษา พยาบาลอย่างไร",
              this.form.boxAppropriate15
            ) +
            "\n" +
            this.checkNull(
              "การรักษาความลับของข้อมูลที่เป็นส่วนตัวของผู้เข้าร่วมโครงการวิจัย นอกจากนักวิจัยแล้ว มีผู้ใดหรือ คณะบุคคลใดที่จะมาตรวจสอบข้อมูลของผู้เข้าร่วมโครงการวิจัยได้บ้าง เช่นข้อมูลจะต้องถูกส่งไปยัง บริษัทยาที่เป็นผู้ให้ทุน คณะกรรมการจริยธรรมสามารถตรวจสอบข้อมูลของการวิจัยได้เช่นเดียวกัน",
              this.form.boxAppropriate16
            ) +
            "\n" +
            this.checkNull(
              "หากเกิดการบาดเจ็บหรือเจ็บป่วยหรือเกิดผลข้างเคียงอันไม่พึงประสงค์ที่เป็นผลมาจากการวิจัยโดยตรงอาสาสมัครจะได้รับการปฏิบัติอย่างไรบ้าง และใครจะเป็นผู้รับผิดชอบในการรักษาพยาบาลรวมถึง ค่าใช้จ่ายในการรักษาตัวแบบผู้ป่วยในโรงพยาบาล เป็นต้น ควรระบุให้ชัดเจน",
              this.form.boxAppropriate17
            ) +
            "\n" +
            this.checkNull(
              "เมื่อเกิดเหตุการณ์อันไม่พึงประสงค์ผู้เข้าร่วมโครงการวิจัยจะติดต่อกับผู้วิจัยหลักได้อย่างไร ควรมี ชื่อ ที่อยู่ เบอร์โทรศัพท์ ที่จะติดต่อได้ 24 ชั่วโมง และเมื่อผู้เข้าร่วมโครงการรู้สึกว่าได้รับการปฏิบัติอย่างไม่เป็นธรรม สามารถ ติดต่อร้องทุกข์ต่อคณะกรรมการได้ด้วยวิธีใด",
              this.form.boxAppropriate18
            ) +
            "\n" +
            this.checkNull(
              "ผู้เข้าร่วมโครงการวิจัย สามารถถอนตัวจากโครงการวิจัยได้ตลอดเวลา และไม่จำเป็นต้องชี้แจง เหตุผลในการถอนตัว ในขณะเดียวกันผู้วิจัย หรือผู้ให้ทุนการวิจัย อาจขอให้ผู้เข้าร่วม โครงการวิจัยออกจากโครงการวิจัยได้เช่นกัน เมื่อมีเหตุผล เช่นอาจเป็นอันตรายต่อผู้เข้าร่วม โครงการวิจัยเอง หรือผู้เข้าร่วมโครงการวิจัยมิได้ปฏิบัติตัวตามขั้นตอนที่ได้ตกลงไว้ในการดำเนินการวิจัย เป็นต้น",
              this.form.boxAppropriate19
            ) +
            "\n" +
            this.checkNull(
              "หากมีข้อมูลใหม่ ที่เกี่ยวข้องกับโครงการวิจัย ผู้วิจัยจะต้องแจ้งให้ผู้เข้าร่วมโครงการวิจัยทราบด้วย (เฉพาะการวิจัยเกี่ยวกับยา)",
              this.form.boxAppropriate20
            ) +
            "\n" +
            this.checkNull(
              "ผู้เข้าร่วมโครงการวิจัยจะได้รับเอกสารชี้แจงที่มีข้อความเดียวกันกับที่ผู้วิจัยเก็บไว้ 1 ชุด",
              this.form.boxAppropriate21
            ) +
            "\n" +
            this.checkNull(
              "ภาษาที่ใช้จะต้องสละสลวย เข้าใจง่าย ไม่ใช้ศัพท์ทางวิทยาศาสตร์ หรือทางการแพทย์ แต่จะต้องเป็น ภาษาที่คนทั่วไปสามารถเข้าใจได้",
              this.form.boxAppropriate22
            ) +
            "\n" +
            this.checkNull(
              "ผู้เข้าร่วมโครงการวิจัยเข้าร่วมโครงการวิจัยนี้โดยความสมัครใจ ไม่มีการบังคับ",
              this.form.boxAppropriate23
            ) +
            "\n" +
            this.checkNull(
              "ที่ลงนาม ผู้เข้าร่วมโครงการวิจัย",
              this.form.boxAppropriate24
            ) +
            "\n" +
            this.checkNull(
              "ที่ลงนาม ผู้ขอคำยินยอมหรือผู้วิจัย",
              this.form.boxAppropriate25
            ) +
            "\n" +
            this.checkNull("ที่ลงนามพยาน (2 คน)", this.form.boxAppropriate26) +
            "\n" +
            this.checkNull(
              "กรณีผู้เข้าร่วมโครงการวิจัยเป็นเด็ก (อายุน้อยกว่า18 ปี) มีที่ลงนามผู้ปกครองหรือผู้แทนโดยชอบธรรม",
              this.form.boxAppropriate27
            ) +
            "\n" +
            this.checkNull(
              "กรณีผู้เข้าร่วมโครงการเป็นเด็กอายุตั้งแต่ 7 ขวบ ถึง 17 ปี มีหนังสือแสดงความยินยอม (Assent form) ให้เด็กสามารถอ่านทำความเข้าใจได้และมีที่ลงนามของเด็ก",
              this.form.boxAppropriate28
            ) +
            "\n";
      }
    },
    checkNull(text, val) {
      console.log(val);
      if (val && val !== undefined && val !== "undefined") {
        return text + "\n" + "- " + val;
      } else {
        return text + "\n" + "- ";
      }
    },
    updateData(name, val) {
      this.form[name] = val;
      let previousKey = this.lastKey
      if(previousKey !== name || val.length == 1) {
        this.autoSave();
      }
      this.lastKey = name;
      this.lastValue = val;
    },
    updateDate(name, val) {
      if (name === "estimateDate") {
        this.form.date = val.date;
        this.dateChange = this.changeDate(val.date);
      }
      if (name === "estimateDateGet") {
        this.form.date = val;
        this.dateChange = this.changeDate(val);
      }
    },
    changeDate(val) {
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    clearRadio(val, name) {
      if (name === "recommendToMeet") {
          if(this.recommendToMeet2 == val.toString()){
              this.form.recommendToMeet = '';
              this.form.expertConsultant = "";
          }else {
          this.form.recommendToMeet = val.toString();
          this.form.expertConsultant = "";
        }
        this.recommendToMeet2 = this.form.recommendToMeet;
      }
    },
    checkbox(no, name) {
      switch (name) {
        case "hasResearcher":
          switch (no) {
            case 1:
              this.isCheckbox1.checkbox1 = true;
              this.isCheckbox1.checkbox2 = false;
              this.form.hasResearcher = no;
              break;
            case 2:
              this.isCheckbox1.checkbox1 = false;
              this.isCheckbox1.checkbox2 = true;
              this.form.hasResearcher = no;
              break;
          }
          break;
        case "hasCoResearcher":
          switch (no) {
            case 1:
              this.isCheckbox2.checkbox1 = true;
              this.isCheckbox2.checkbox2 = false;
              this.form.hasCoResearcher = no;
              break;
            case 2:
              this.isCheckbox2.checkbox1 = false;
              this.isCheckbox2.checkbox2 = true;
              this.form.hasCoResearcher = no;
              break;
          }
          break;
        case "consentRequest":
          switch (no) {
            case 1:
              this.isCheckbox3.checkbox1 = true;
              this.isCheckbox3.checkbox2 = false;
              this.isCheckbox3.checkbox3 = false;
              this.form.consentRequest = no;
              break;
            case 2:
              this.isCheckbox3.checkbox1 = false;
              this.isCheckbox3.checkbox2 = true;
              this.isCheckbox3.checkbox3 = false;
              this.form.consentRequest = no;
              break;
            case 3:
              this.isCheckbox3.checkbox1 = false;
              this.isCheckbox3.checkbox2 = false;
              this.isCheckbox3.checkbox3 = true;
              this.form.consentRequest = no;
              break;
          }
          break;
        case "isAppropriate1":
          switch (no) {
            case 1:
              this.isCheckbox4.checkbox1 = true;
              this.isCheckbox4.checkbox2 = false;
              this.isCheckbox4.checkbox3 = false;
              this.form.isAppropriate1 = no;
              break;
            case 2:
              this.isCheckbox4.checkbox1 = false;
              this.isCheckbox4.checkbox2 = true;
              this.isCheckbox4.checkbox3 = false;
              this.form.isAppropriate1 = no;
              break;
            case 3:
              this.isCheckbox4.checkbox1 = false;
              this.isCheckbox4.checkbox2 = false;
              this.isCheckbox4.checkbox3 = true;
              this.form.isAppropriate1 = no;
              break;
          }
          break;
        case "isAppropriate2":
          switch (no) {
            case 1:
              this.isCheckbox5.checkbox1 = true;
              this.isCheckbox5.checkbox2 = false;
              this.isCheckbox5.checkbox3 = false;
              this.form.isAppropriate2 = no;
              break;
            case 2:
              this.isCheckbox5.checkbox1 = false;
              this.isCheckbox5.checkbox2 = true;
              this.isCheckbox5.checkbox3 = false;
              this.form.isAppropriate2 = no;
              break;
            case 3:
              this.isCheckbox5.checkbox1 = false;
              this.isCheckbox5.checkbox2 = false;
              this.isCheckbox5.checkbox3 = true;
              this.form.isAppropriate2 = no;
              break;
          }
          break;
        case "isAppropriate3":
          switch (no) {
            case 1:
              this.isCheckbox6.checkbox1 = true;
              this.isCheckbox6.checkbox2 = false;
              this.isCheckbox6.checkbox3 = false;
              this.form.isAppropriate3 = no;
              break;
            case 2:
              this.isCheckbox6.checkbox1 = false;
              this.isCheckbox6.checkbox2 = true;
              this.isCheckbox6.checkbox3 = false;
              this.form.isAppropriate3 = no;
              break;
            case 3:
              this.isCheckbox6.checkbox1 = false;
              this.isCheckbox6.checkbox2 = false;
              this.isCheckbox6.checkbox3 = true;
              this.form.isAppropriate3 = no;
              break;
          }
          break;
        case "isAppropriate4":
          switch (no) {
            case 1:
              this.isCheckbox7.checkbox1 = true;
              this.isCheckbox7.checkbox2 = false;
              this.isCheckbox7.checkbox3 = false;
              this.form.isAppropriate4 = no;
              break;
            case 2:
              this.isCheckbox7.checkbox1 = false;
              this.isCheckbox7.checkbox2 = true;
              this.isCheckbox7.checkbox3 = false;
              this.form.isAppropriate4 = no;
              break;
            case 3:
              this.isCheckbox7.checkbox1 = false;
              this.isCheckbox7.checkbox2 = false;
              this.isCheckbox7.checkbox3 = true;
              this.form.isAppropriate4 = no;
              break;
          }
          break;
        case "isAppropriate5":
          switch (no) {
            case 1:
              this.isCheckbox8.checkbox1 = true;
              this.isCheckbox8.checkbox2 = false;
              this.isCheckbox8.checkbox3 = false;
              this.form.isAppropriate5 = no;
              break;
            case 2:
              this.isCheckbox8.checkbox1 = false;
              this.isCheckbox8.checkbox2 = true;
              this.isCheckbox8.checkbox3 = false;
              this.form.isAppropriate5 = no;
              break;
            case 3:
              this.isCheckbox8.checkbox1 = false;
              this.isCheckbox8.checkbox2 = false;
              this.isCheckbox8.checkbox3 = true;
              this.form.isAppropriate5 = no;
              break;
          }
          break;
        case "isAppropriate6":
          switch (no) {
            case 1:
              this.isCheckbox9.checkbox1 = true;
              this.isCheckbox9.checkbox2 = false;
              this.isCheckbox9.checkbox3 = false;
              this.form.isAppropriate6 = no;
              break;
            case 2:
              this.isCheckbox9.checkbox1 = false;
              this.isCheckbox9.checkbox2 = true;
              this.isCheckbox9.checkbox3 = false;
              this.form.isAppropriate6 = no;
              break;
            case 3:
              this.isCheckbox9.checkbox1 = false;
              this.isCheckbox9.checkbox2 = false;
              this.isCheckbox9.checkbox3 = true;
              this.form.isAppropriate6 = no;
              break;
          }
          break;
        case "isAppropriate7":
          switch (no) {
            case 1:
              this.isCheckbox10.checkbox1 = true;
              this.isCheckbox10.checkbox2 = false;
              this.isCheckbox10.checkbox3 = false;
              this.form.isAppropriate7 = no;
              break;
            case 2:
              this.isCheckbox10.checkbox1 = false;
              this.isCheckbox10.checkbox2 = true;
              this.isCheckbox10.checkbox3 = false;
              this.form.isAppropriate7 = no;
              break;
            case 3:
              this.isCheckbox10.checkbox1 = false;
              this.isCheckbox10.checkbox2 = false;
              this.isCheckbox10.checkbox3 = true;
              this.form.isAppropriate7 = no;
              break;
          }
          break;
        case "isAppropriate8":
          switch (no) {
            case 1:
              this.isCheckbox11.checkbox1 = true;
              this.isCheckbox11.checkbox2 = false;
              this.isCheckbox11.checkbox3 = false;
              this.form.isAppropriate8 = no;
              break;
            case 2:
              this.isCheckbox11.checkbox1 = false;
              this.isCheckbox11.checkbox2 = true;
              this.isCheckbox11.checkbox3 = false;
              this.form.isAppropriate8 = no;
              break;
            case 3:
              this.isCheckbox11.checkbox1 = false;
              this.isCheckbox11.checkbox2 = false;
              this.isCheckbox11.checkbox3 = true;
              this.form.isAppropriate8 = no;
              break;
          }
          break;
        case "isAppropriate9":
          switch (no) {
            case 1:
              this.isCheckbox12.checkbox1 = true;
              this.isCheckbox12.checkbox2 = false;
              this.isCheckbox12.checkbox3 = false;
              this.form.isAppropriate9 = no;
              break;
            case 2:
              this.isCheckbox12.checkbox1 = false;
              this.isCheckbox12.checkbox2 = true;
              this.isCheckbox12.checkbox3 = false;
              this.form.isAppropriate9 = no;
              break;
            case 3:
              this.isCheckbox12.checkbox1 = false;
              this.isCheckbox12.checkbox2 = false;
              this.isCheckbox12.checkbox3 = true;
              this.form.isAppropriate9 = no;
              break;
          }
          break;
        case "isAppropriate10":
          switch (no) {
            case 1:
              this.isCheckbox13.checkbox1 = true;
              this.isCheckbox13.checkbox2 = false;
              this.isCheckbox13.checkbox3 = false;
              this.form.isAppropriate10 = no;
              break;
            case 2:
              this.isCheckbox13.checkbox1 = false;
              this.isCheckbox13.checkbox2 = true;
              this.isCheckbox13.checkbox3 = false;
              this.form.isAppropriate10 = no;
              break;
            case 3:
              this.isCheckbox13.checkbox1 = false;
              this.isCheckbox13.checkbox2 = false;
              this.isCheckbox13.checkbox3 = true;
              this.form.isAppropriate10 = no;
              break;
          }
          break;
        case "isAppropriate11":
          switch (no) {
            case 1:
              this.isCheckbox14.checkbox1 = true;
              this.isCheckbox14.checkbox2 = false;
              this.isCheckbox14.checkbox3 = false;
              this.form.isAppropriate11 = no;
              break;
            case 2:
              this.isCheckbox14.checkbox1 = false;
              this.isCheckbox14.checkbox2 = true;
              this.isCheckbox14.checkbox3 = false;
              this.form.isAppropriate11 = no;
              break;
            case 3:
              this.isCheckbox14.checkbox1 = false;
              this.isCheckbox14.checkbox2 = false;
              this.isCheckbox14.checkbox3 = true;
              this.form.isAppropriate11 = no;
              break;
          }
          break;
        case "isAppropriate12":
          switch (no) {
            case 1:
              this.isCheckbox15.checkbox1 = true;
              this.isCheckbox15.checkbox2 = false;
              this.isCheckbox15.checkbox3 = false;
              this.form.isAppropriate12 = no;
              break;
            case 2:
              this.isCheckbox15.checkbox1 = false;
              this.isCheckbox15.checkbox2 = true;
              this.isCheckbox15.checkbox3 = false;
              this.form.isAppropriate12 = no;
              break;
            case 3:
              this.isCheckbox15.checkbox1 = false;
              this.isCheckbox15.checkbox2 = false;
              this.isCheckbox15.checkbox3 = true;
              this.form.isAppropriate12 = no;
              break;
          }
          break;
        case "isAppropriate13":
          switch (no) {
            case 1:
              this.isCheckbox16.checkbox1 = true;
              this.isCheckbox16.checkbox2 = false;
              this.isCheckbox16.checkbox3 = false;
              this.form.isAppropriate13 = no;
              break;
            case 2:
              this.isCheckbox16.checkbox1 = false;
              this.isCheckbox16.checkbox2 = true;
              this.isCheckbox16.checkbox3 = false;
              this.form.isAppropriate13 = no;
              break;
            case 3:
              this.isCheckbox16.checkbox1 = false;
              this.isCheckbox16.checkbox2 = false;
              this.isCheckbox16.checkbox3 = true;
              this.form.isAppropriate13 = no;
              break;
          }
          break;
        case "isAppropriate14":
          switch (no) {
            case 1:
              this.isCheckbox17.checkbox1 = true;
              this.isCheckbox17.checkbox2 = false;
              this.isCheckbox17.checkbox3 = false;
              this.form.isAppropriate14 = no;
              break;
            case 2:
              this.isCheckbox17.checkbox1 = false;
              this.isCheckbox17.checkbox2 = true;
              this.isCheckbox17.checkbox3 = false;
              this.form.isAppropriate14 = no;
              break;
            case 3:
              this.isCheckbox17.checkbox1 = false;
              this.isCheckbox17.checkbox2 = false;
              this.isCheckbox17.checkbox3 = true;
              this.form.isAppropriate14 = no;
              break;
          }
          break;
        case "isAppropriate15":
          switch (no) {
            case 1:
              this.isCheckbox18.checkbox1 = true;
              this.isCheckbox18.checkbox2 = false;
              this.isCheckbox18.checkbox3 = false;
              this.form.isAppropriate15 = no;
              break;
            case 2:
              this.isCheckbox18.checkbox1 = false;
              this.isCheckbox18.checkbox2 = true;
              this.isCheckbox18.checkbox3 = false;
              this.form.isAppropriate15 = no;
              break;
            case 3:
              this.isCheckbox18.checkbox1 = false;
              this.isCheckbox18.checkbox2 = false;
              this.isCheckbox18.checkbox3 = true;
              this.form.isAppropriate15 = no;
              break;
          }
          break;
        case "isAppropriate16":
          switch (no) {
            case 1:
              this.isCheckbox19.checkbox1 = true;
              this.isCheckbox19.checkbox2 = false;
              this.isCheckbox19.checkbox3 = false;
              this.form.isAppropriate16 = no;
              break;
            case 2:
              this.isCheckbox19.checkbox1 = false;
              this.isCheckbox19.checkbox2 = true;
              this.isCheckbox19.checkbox3 = false;
              this.form.isAppropriate16 = no;
              break;
            case 3:
              this.isCheckbox19.checkbox1 = false;
              this.isCheckbox19.checkbox2 = false;
              this.isCheckbox19.checkbox3 = true;
              this.form.isAppropriate16 = no;
              break;
          }
          break;
        case "isAppropriate17":
          switch (no) {
            case 1:
              this.isCheckbox20.checkbox1 = true;
              this.isCheckbox20.checkbox2 = false;
              this.isCheckbox20.checkbox3 = false;
              this.form.isAppropriate17 = no;
              break;
            case 2:
              this.isCheckbox20.checkbox1 = false;
              this.isCheckbox20.checkbox2 = true;
              this.isCheckbox20.checkbox3 = false;
              this.form.isAppropriate17 = no;
              break;
            case 3:
              this.isCheckbox20.checkbox1 = false;
              this.isCheckbox20.checkbox2 = false;
              this.isCheckbox20.checkbox3 = true;
              this.form.isAppropriate17 = no;
              break;
          }
          break;
        case "isAppropriate18":
          switch (no) {
            case 1:
              this.isCheckbox21.checkbox1 = true;
              this.isCheckbox21.checkbox2 = false;
              this.isCheckbox21.checkbox3 = false;
              this.form.isAppropriate18 = no;
              break;
            case 2:
              this.isCheckbox21.checkbox1 = false;
              this.isCheckbox21.checkbox2 = true;
              this.isCheckbox21.checkbox3 = false;
              this.form.isAppropriate18 = no;
              break;
            case 3:
              this.isCheckbox21.checkbox1 = false;
              this.isCheckbox21.checkbox2 = false;
              this.isCheckbox21.checkbox3 = true;
              this.form.isAppropriate18 = no;
              break;
          }
          break;
        case "isAppropriate19":
          switch (no) {
            case 1:
              this.isCheckbox22.checkbox1 = true;
              this.isCheckbox22.checkbox2 = false;
              this.isCheckbox22.checkbox3 = false;
              this.form.isAppropriate19 = no;
              break;
            case 2:
              this.isCheckbox22.checkbox1 = false;
              this.isCheckbox22.checkbox2 = true;
              this.isCheckbox22.checkbox3 = false;
              this.form.isAppropriate19 = no;
              break;
            case 3:
              this.isCheckbox22.checkbox1 = false;
              this.isCheckbox22.checkbox2 = false;
              this.isCheckbox22.checkbox3 = true;
              this.form.isAppropriate19 = no;
              break;
          }
          break;
        case "isAppropriate20":
          switch (no) {
            case 1:
              this.isCheckbox23.checkbox1 = true;
              this.isCheckbox23.checkbox2 = false;
              this.isCheckbox23.checkbox3 = false;
              this.form.isAppropriate20 = no;
              break;
            case 2:
              this.isCheckbox23.checkbox1 = false;
              this.isCheckbox23.checkbox2 = true;
              this.isCheckbox23.checkbox3 = false;
              this.form.isAppropriate20 = no;
              break;
            case 3:
              this.isCheckbox23.checkbox1 = false;
              this.isCheckbox23.checkbox2 = false;
              this.isCheckbox23.checkbox3 = true;
              this.form.isAppropriate20 = no;
              break;
          }
          break;
        case "isAppropriate21":
          switch (no) {
            case 1:
              this.isCheckbox24.checkbox1 = true;
              this.isCheckbox24.checkbox2 = false;
              this.isCheckbox24.checkbox3 = false;
              this.form.isAppropriate21 = no;
              break;
            case 2:
              this.isCheckbox24.checkbox1 = false;
              this.isCheckbox24.checkbox2 = true;
              this.isCheckbox24.checkbox3 = false;
              this.form.isAppropriate21 = no;
              break;
            case 3:
              this.isCheckbox24.checkbox1 = false;
              this.isCheckbox24.checkbox2 = false;
              this.isCheckbox24.checkbox3 = true;
              this.form.isAppropriate21 = no;
              break;
          }
          break;
        case "isAppropriate22":
          switch (no) {
            case 1:
              this.isCheckbox25.checkbox1 = true;
              this.isCheckbox25.checkbox2 = false;
              this.isCheckbox25.checkbox3 = false;
              this.form.isAppropriate22 = no;
              break;
            case 2:
              this.isCheckbox25.checkbox1 = false;
              this.isCheckbox25.checkbox2 = true;
              this.isCheckbox25.checkbox3 = false;
              this.form.isAppropriate22 = no;
              break;
            case 3:
              this.isCheckbox25.checkbox1 = false;
              this.isCheckbox25.checkbox2 = false;
              this.isCheckbox25.checkbox3 = true;
              this.form.isAppropriate22 = no;
              break;
          }
          break;
        case "isAppropriate23":
          switch (no) {
            case 1:
              this.isCheckbox26.checkbox1 = true;
              this.isCheckbox26.checkbox2 = false;
              this.isCheckbox26.checkbox3 = false;
              this.form.isAppropriate23 = no;
              break;
            case 2:
              this.isCheckbox26.checkbox1 = false;
              this.isCheckbox26.checkbox2 = true;
              this.isCheckbox26.checkbox3 = false;
              this.form.isAppropriate23 = no;
              break;
            case 3:
              this.isCheckbox26.checkbox1 = false;
              this.isCheckbox26.checkbox2 = false;
              this.isCheckbox26.checkbox3 = true;
              this.form.isAppropriate23 = no;
              break;
          }
          break;
        case "isAppropriate24":
          switch (no) {
            case 1:
              this.isCheckbox27.checkbox1 = true;
              this.isCheckbox27.checkbox2 = false;
              this.isCheckbox27.checkbox3 = false;
              this.form.isAppropriate24 = no;
              break;
            case 2:
              this.isCheckbox27.checkbox1 = false;
              this.isCheckbox27.checkbox2 = true;
              this.isCheckbox27.checkbox3 = false;
              this.form.isAppropriate24 = no;
              break;
            case 3:
              this.isCheckbox27.checkbox1 = false;
              this.isCheckbox27.checkbox2 = false;
              this.isCheckbox27.checkbox3 = true;
              this.form.isAppropriate24 = no;
              break;
          }
          break;
        case "isAppropriate25":
          switch (no) {
            case 1:
              this.isCheckbox28.checkbox1 = true;
              this.isCheckbox28.checkbox2 = false;
              this.isCheckbox28.checkbox3 = false;
              this.form.isAppropriate25 = no;
              break;
            case 2:
              this.isCheckbox28.checkbox1 = false;
              this.isCheckbox28.checkbox2 = true;
              this.isCheckbox28.checkbox3 = false;
              this.form.isAppropriate25 = no;
              break;
            case 3:
              this.isCheckbox28.checkbox1 = false;
              this.isCheckbox28.checkbox2 = false;
              this.isCheckbox28.checkbox3 = true;
              this.form.isAppropriate25 = no;
              break;
          }
          break;
        case "isAppropriate26":
          switch (no) {
            case 1:
              this.isCheckbox29.checkbox1 = true;
              this.isCheckbox29.checkbox2 = false;
              this.isCheckbox29.checkbox3 = false;
              this.form.isAppropriate26 = no;
              break;
            case 2:
              this.isCheckbox29.checkbox1 = false;
              this.isCheckbox29.checkbox2 = true;
              this.isCheckbox29.checkbox3 = false;
              this.form.isAppropriate26 = no;
              break;
            case 3:
              this.isCheckbox29.checkbox1 = false;
              this.isCheckbox29.checkbox2 = false;
              this.isCheckbox29.checkbox3 = true;
              this.form.isAppropriate26 = no;
              break;
          }
          break;
        case "isAppropriate27":
          switch (no) {
            case 1:
              this.isCheckbox30.checkbox1 = true;
              this.isCheckbox30.checkbox2 = false;
              this.isCheckbox30.checkbox3 = false;
              this.form.isAppropriate27 = no;
              break;
            case 2:
              this.isCheckbox30.checkbox1 = false;
              this.isCheckbox30.checkbox2 = true;
              this.isCheckbox30.checkbox3 = false;
              this.form.isAppropriate27 = no;
              break;
            case 3:
              this.isCheckbox30.checkbox1 = false;
              this.isCheckbox30.checkbox2 = false;
              this.isCheckbox30.checkbox3 = true;
              this.form.isAppropriate27 = no;
              break;
          }
          break;
        case "isAppropriate28":
          switch (no) {
            case 1:
              this.isCheckbox31.checkbox1 = true;
              this.isCheckbox31.checkbox2 = false;
              this.isCheckbox31.checkbox3 = false;
              this.form.isAppropriate28 = no;
              break;
            case 2:
              this.isCheckbox31.checkbox1 = false;
              this.isCheckbox31.checkbox2 = true;
              this.isCheckbox31.checkbox3 = false;
              this.form.isAppropriate28 = no;
              break;
            case 3:
              this.isCheckbox31.checkbox1 = false;
              this.isCheckbox31.checkbox2 = false;
              this.isCheckbox31.checkbox3 = true;
              this.form.isAppropriate28 = no;
              break;
          }
          break;
      }
      this.updateData(name, no)
    },
    save(isSend) {
      Swal.fire({
        title: isSend ? "คุณต้องการส่งแบบประเมินหรือไม่?" :"คุณต้องการบันทึกหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.form["researchID"] = this.$route.query.id;
          this.form["isSubmit"] = isSend;
          this.$store
            .dispatch("FormRO/saveRO04_1", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.go(-1);
              });
              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }else{
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.message,
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                })
              }
            });
        }
      });
    },
    autoSave() {
      if(this.isSubmit){
        return false
      }else{
        console.log('this.isSubmit', this.isSubmit)
      }
      let payload = {
        'researchID': this.$route.query.id,
        'isSubmit': 0,
        'order': this.$route.query.order,
      }
      payload[this.lastKey] = this.lastValue,
          this.$store
            .dispatch("FormRO/saveRO04_1", payload)
            .catch((e) => {
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }else{
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.message,
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                })
              }
            });
    },
    getRO04_1() {
      this.isLoading = true;
      this.$store
        .dispatch("FormRO/getRO04_1", this.$route.query.id)
        .then((res) => {
          if (res !== "don't have ro04_1 yet") {
            console.log("getRO04_1 : ", res);
            this.isSubmit = res.isSubmit;
            this.form.researchID = res.researchID;
            this.form.researchName = res.researchName;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchCode = res.researchCode;
            this.checkbox(res.hasResearcher, "hasResearcher");
            this.form.adviceResearcher = res.adviceResearcher;
            this.checkbox(res.hasCoResearcher, "hasCoResearcher");
            this.form.adviceCoResearcher = res.adviceCoResearcher;
            this.checkbox(res.consentRequest, "consentRequest");
            this.form.consentRequestAdvice = res.consentRequestAdvice;
            this.form.adviceTextBox = res.adviceTextBox;
            this.checkbox(res.isAppropriate1, "isAppropriate1");
            this.checkbox(res.isAppropriate2, "isAppropriate2");
            this.checkbox(res.isAppropriate3, "isAppropriate3");
            this.checkbox(res.isAppropriate4, "isAppropriate4");
            this.checkbox(res.isAppropriate5, "isAppropriate5");
            this.checkbox(res.isAppropriate6, "isAppropriate6");
            this.checkbox(res.isAppropriate7, "isAppropriate7");
            this.checkbox(res.isAppropriate8, "isAppropriate8");
            this.checkbox(res.isAppropriate9, "isAppropriate9");
            this.checkbox(res.isAppropriate10, "isAppropriate10");
            this.checkbox(res.isAppropriate11, "isAppropriate11");
            this.checkbox(res.isAppropriate12, "isAppropriate12");
            this.checkbox(res.isAppropriate13, "isAppropriate13");
            this.checkbox(res.isAppropriate14, "isAppropriate14");
            this.checkbox(res.isAppropriate15, "isAppropriate15");
            this.checkbox(res.isAppropriate16, "isAppropriate16");
            this.checkbox(res.isAppropriate17, "isAppropriate17");
            this.checkbox(res.isAppropriate18, "isAppropriate18");
            this.checkbox(res.isAppropriate19, "isAppropriate19");
            this.checkbox(res.isAppropriate20, "isAppropriate20");
            this.checkbox(res.isAppropriate21, "isAppropriate21");
            this.checkbox(res.isAppropriate22, "isAppropriate22");
            this.checkbox(res.isAppropriate23, "isAppropriate23");
            this.checkbox(res.isAppropriate24, "isAppropriate24");
            this.checkbox(res.isAppropriate25, "isAppropriate25");
            this.checkbox(res.isAppropriate26, "isAppropriate26");
            this.checkbox(res.isAppropriate27, "isAppropriate27");
            this.checkbox(res.isAppropriate28, "isAppropriate28");
            this.checkbox(res.isAppropriate29, "isAppropriate29");
            this.checkbox(res.isAppropriate30, "isAppropriate30");
            this.checkbox(res.isAppropriate31, "isAppropriate31");
            this.form.boxAppropriate1 = res.boxAppropriate1;
            this.form.boxAppropriate2 = res.boxAppropriate2;
            this.form.boxAppropriate3 = res.boxAppropriate3;
            this.form.boxAppropriate4 = res.boxAppropriate4;
            this.form.boxAppropriate5 = res.boxAppropriate5;
            this.form.boxAppropriate6 = res.boxAppropriate6;
            this.form.boxAppropriate7 = res.boxAppropriate7;
            this.form.boxAppropriate8 = res.boxAppropriate8;
            this.form.boxAppropriate9 = res.boxAppropriate9;
            this.form.boxAppropriate10 = res.boxAppropriate10;
            this.form.boxAppropriate11 = res.boxAppropriate11;
            this.form.boxAppropriate12 = res.boxAppropriate12;
            this.form.boxAppropriate13 = res.boxAppropriate13;
            this.form.boxAppropriate14 = res.boxAppropriate14;
            this.form.boxAppropriate15 = res.boxAppropriate15;
            this.form.boxAppropriate16 = res.boxAppropriate16;
            this.form.boxAppropriate17 = res.boxAppropriate17;
            this.form.boxAppropriate18 = res.boxAppropriate18;
            this.form.boxAppropriate19 = res.boxAppropriate19;
            this.form.boxAppropriate20 = res.boxAppropriate20;
            this.form.boxAppropriate21 = res.boxAppropriate21;
            this.form.boxAppropriate22 = res.boxAppropriate22;
            this.form.boxAppropriate23 = res.boxAppropriate23;
            this.form.boxAppropriate24 = res.boxAppropriate24;
            this.form.boxAppropriate25 = res.boxAppropriate25;
            this.form.boxAppropriate26 = res.boxAppropriate26;
            this.form.boxAppropriate27 = res.boxAppropriate27;
            this.form.boxAppropriate28 = res.boxAppropriate28;
            this.form.adviceTextBox2 = res.adviceTextBox2;
            this.form.recommendToMeet = res.recommendToMeet;
            this.recommendToMeet2 = this.form.recommendToMeet;
            this.form.expertConsultant = res.expertConsultant;
            if(res.signature)
              this.form.signature = res.signature;
            else
              this.form.signature = this.$route.query.reviewerName;
            this.form.order = res.order;
            this.updateDate("estimateDateGet", res.date);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.table-ro4-1 {
  /*** Table Styles **/
  .table-style-ro04-1 {
    .v-input__slot {
      align-items: center;
      justify-content: center;
    }
    .table-fill-ro04-1 {
      background: white;
      border-radius: 3px;
      border-collapse: collapse;
      margin: auto;
      padding: 5px;
      width: 100%;
      //   box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
      animation: float 5s infinite;
      /*border-bottom: 5px solid #544A44;*/
    }

    th {
      color: #ffffff;
      background: #3e7662;
      /*border-top:5px solid #544A44;*/
      border-right: 0.75px solid gray;
      font-weight: 700;
      padding: 15px;
      vertical-align: middle;
    }
    tr {
      border-top: 1px solid #544a44;
      //   border-bottom: 1px solid #544a44;
    }
    th:first-child {
      border-top-left-radius: 3px;
    }

    th:last-child {
      border-top-right-radius: 3px;
      border-right: none;
    }

    tr:first-child {
      /*border-top: none;*/
    }

    tr:last-child {
      /*border-bottom:5px solid #544A44;*/
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 3px;
    }

    tr:last-child td:last-child {
      border-bottom-right-radius: 3px;
    }

    td {
      background: #ffffff;
      padding: 10px 30px 10px 30px;
      text-align: left;
      vertical-align: middle;
      font-weight: 700;
      color: black;
      border-right: 0.5px solid gray;
      border-top: 0.5px solid gray;
    }

    td:last-child {
      border-right: 0px;
    }

    th.text-left {
      text-align: left;
    }

    th.text-center {
      text-align: center;
    }

    th.text-right {
      text-align: right;
    }

    td.text-left {
      text-align: left;
    }

    td.text-center {
      text-align: center;
    }

    td.text-right {
      text-align: right;
    }
  }
}

.text-field-color {
  .theme--light.v-input,
  .theme--light.v-input input,
  .theme--light.v-input textarea {
    color: #cc3d45;
  }
}
.text-field-margin {
  .v-text-field {
    padding: 0;
    margin: 0;
  }
}
</style>
